import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=7be24396&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7be24396')) {
      api.createRecord('7be24396', component.options)
    } else {
      api.reload('7be24396', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=7be24396&", function () {
      api.rerender('7be24396', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/integrations/DashboardApps/Index.vue"
export default component.exports